export enum WizardModeKey {
  Full = "full",
  SimpleOpinion = "simpleOpinion",
  SimpleQuiz = "simpleQuiz"
}
